import dataJson from "@/../public/data.json";
import "./index.less";

const prefix = "design-concept";

function DesignConcept() {
  const {design}=dataJson
  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-title`}>{design.design_concept_title}</div>
        <div className={`${prefix}-describe`}>{design.design_concept_describe}</div>
        <img src={design.design_concept} alt="" className={`${prefix}-img`} />
      </div>
    </div>
  );
}

export default DesignConcept;
